<template>
  <rhcn-drawer
    title="message.permission.resetPassword"
    :description="$t('message.user.resetPwdTip', { email: $route.query.email })"
    @on-close="onClose">
    <div class="form">
      <validation-component
        ref="resetPwdFormRef"
        :validation-condition="resetPwdCondition">
      </validation-component>
      <div class="margin-top-18">
        <el-button :loading="loading" style="width:100%;" type="primary" @click="resetPwdSubmit">{{$t('message.permission.resetPassword')}}</el-button>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import { updatePassword } from '@/api/common/user';
import RhcnDrawer from '@/components/drawer/index.vue';
import { REQUIRED, VALIDATE_PASSWORD, PASSWORD_LENGTH, PASSWORD_STRENGTH } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';

export default {
  components: { RhcnDrawer, ValidationComponent },
  data() {
    return {
      resetPwdCondition: [
        {
          key: 'password',
          name: 'message.user.newPasword',
          type: 'password',
          defValue: '',
          isShowStar: true,
          rule: [{ validator: this.resetPwdValidate, trigger: 'blur' }],
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.newPasword').toLowerCase() }),
          validator: this.resetPwdValidate,
        },
        {
          key: 'confirmPassword',
          name: 'message.user.confirmPasword',
          type: 'password',
          defValue: '',
          isShowStar: true,
          rule: [{ validator: this.resetPwdRepeatValidate, trigger: 'blur' }],
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.confirmPasword').toLowerCase() }),
          validator: this.resetPwdRepeatValidate,
        },
      ],
      loading: false,
    };
  },
  beforeCreate() {
    const oid = this.$route.query.oid;
    if (!oid) {
      this.$router.push({ path: '/user/forget-password/auth' });
    }
  },
  methods: {
    resetPwdSubmit() {
      this.$refs.resetPwdFormRef.toFormValid(this.resetPwdHttpRequest);
    },
    resetPwdHttpRequest() {
      this.loading = true;
      const data = {
        operatorId: this.$route.query.oid,
        loginId: this.$route.query.email,
        password: this.$refs.resetPwdFormRef.getItemValue('password'),
      };
      updatePassword(data).then(() => {
        this.$router.push({ path: '/user/login' });
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    resetPwdValidate(rule, value, callback) {
      // 必填验证
      if (REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.newPasword').toLowerCase() })));
        return;
      }
      // 密码格式验证
      if (!VALIDATE_PASSWORD.regExp.test(value)) {
        callback(new Error(this.$t(VALIDATE_PASSWORD.tips)));
        return;
      }
      if (!PASSWORD_LENGTH.regExp.test(value)) {
        callback(new Error(this.$t(PASSWORD_LENGTH.tips)));
        return;
      }
      if (!PASSWORD_STRENGTH.regExp.test(value)) {
        callback(new Error(this.$t(PASSWORD_STRENGTH.tips)));
        return;
      }
      callback();
    },
    resetPwdRepeatValidate(rule, value, callback) {
      // 必填验证
      if (REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.newPasword').toLowerCase() })));
        return;
      }
      if (this.$refs.resetPwdFormRef.getItemValue('password') !== value) {
        callback(new Error(this.$t('message.validator.passwordConfirm')));
        return;
      }
      callback();
    },
    onClose() {
      this.$router.push({
        path: '/user/login',
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/unauth-right.scss';
</style>
